export default {
    API_PATH: import.meta.env.VITE_API_PATH || '/api',
    STAGE: import.meta.env.VITE_STAGE || 'prod',
    IS_DEV: import.meta.env.VITE_STAGE === 'dev',
};
